import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/manilius.pdf'; /*Change pdf*/
import { Helmet } from 'react-helmet';

function Page() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {       /*Change left hand panel content*/
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
        Manuscript held by G. W. Leibniz Bibliothek, Hanover<br />
        Shelfmark LH 1, 1, 4 Bl. 60<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
        Date: 1707 (?)<br /><br />
        Translated from the Latin<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (183k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>On Book 4 of Manilius\' \'Astronomica\' </title> {/*Change title*/}
            <meta name="description" content="An English translation of ON BOOK 4 OF MANILIUS' 'ASTRONOMICA' by Gottfried Wilhelm Leibniz, from 1678 (?)" /> {/*Change meta description*/}
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ: ON BOOK 4 OF MANILIUS' <var>ASTRONOMICA</var></h2> {/*Change title*/}
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br /> {/*Change page content*/}
                 [<b>LH 1, 1, 4 Bl. 60</b>]<br /><br />
                <center>Manilius, <var>Astronomica</var>, book 4</center><br />

                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;“<var>Can one doubt that a divinity dwells within our breasts and that our souls return to the heaven whence they came?</var><a name="1" href="#note1"><sup>1</sup></a> Can one doubt that, just as the world, composed of the elements of ether<a name="2" href="#note2"><sup>2</sup></a> and fire on high and earth and water, houses an intelligence which, spread throughout it, directs the whole, so too with us the bodies of our earthly condition and our life-blood house a mind which directs every part and animates the man? <var>Why wonder that men can comprehend heaven, when heaven exists in their very beings and each one is in a smaller likeness the image of God himself</var>?<a name="3" href="#note3"><sup>3</sup></a> Are we to say<a name="4" href="#note4"><sup>4</sup></a> that man is born of aught but heaven? All the other animals lie prostrate on the earth or submerged in water, or else hover in the air; all alike have sleep and food and the senses<a name="5" href="#note5"><sup>5</sup></a> [for their delights; the strength of an animal is measured only by its size and its value]<a name="6" href="#note6"><sup>6</sup></a> by its limbs, and since it has no intelligence it lacks speech, too. The breed of man, who rules all tilings, is alone reared equal to the inquiry into nature, the power of speech, breadth of understanding, the acquisition of various skills: he has left the open air for the world,<a name="7" href="#note7"><sup>7</sup></a> tamed the land to yield him its fruits, made the beasts his slaves, and laid a pathway on the sea; he alone stands with the citadel of his head raised high and, triumphantly directing to the stars his star-like eyes, looks ever more closely at Olympus <var>and inquires into the nature of Jove himself</var>;<a name="8" href="#note8"><sup>8</sup></a> nor does he rest content with the outward appearance of the gods, but probes into heaven's depths and, in his quest of a being akin to his own, seeks himself among the stars.”<a name="9" href="#note9"><sup>9</sup></a><br /> 
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;When Manilius says “Why wonder that men can comprehend heaven, when heaven exists in their very beings and each one is in a smaller likeness the image of God himself?”, he spoke more truthfully than he thought.<a name="10" href="#note10"><sup>10</sup></a>


                <br /><br /><br />
                <hr className='rightcol-hr' />
                <br /><br />
                NOTES:<br /><br />
                <a name="note1" href="#1">1.</a> The italics are Leibniz's.<br />
                <a name="note2" href="#2">2.</a> Leibniz here changes “aeris” [air] to “aetheris” [ether].<br />
                <a name="note3" href="#3">3.</a> The italics are Leibniz's.<br />
                <a name="note4" href="#4">4.</a> Leibniz here changes “credere” [believe] to “dicere” [say].<br />
                <a name="note5" href="#5">5.</a> Leibniz here changes “venusque” [and sex] to “sensumque” [and the senses].<br />
                <a name="note6" href="#6">6.</a> Leibniz omits the part of the passage in square brackets.<br />
                <a name="note7" href="#7">7.</a> Leibniz here changes “urbes” [for city-life] to “orbem” [world].<br />
                <a name="note8" href="#8">8.</a> The italics are Leibniz's.<br />
                <a name="note9" href="#9">9.</a> Manilius, <var>Astronomica</var>, IV. 886-910. English translation modified from Manilius, <var>Astronomica</var>, ed. and trans. G. P. Goold (London: William Heinemann, 1977), 293-295.<br />
                <a name="note10" href="#10">10.</a> &quot;The final clause was written first in Latin (parts of which were subsequently crossed out) and then in French.<br /><br /><br />
                  &#169; Lloyd Strickland 2023
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Page;
